import React from 'react';
import css from './DocumentationPageProWidget.module.scss';
import ManualsLogo from '../../assets/manuals-logo.svg';
import { useTranslation } from 'react-i18next';

export const DocumentationPageProWidget: React.FC = () => {
    const { t } = useTranslation('DocumentationTab');
    return (
        <div>
            <div className={css.manualsIcon}>
                <ManualsLogo />
            </div>
            <div className={css.middleContainer}>
                <p className={css.kalmarText}>{t('Search manuals with serial number')}</p>
            </div>
        </div>
    );
};
